import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css'; // Custom CSS for additional styling

// Register Chart.js components

const WalletUI = () => {
  const [metal, setMetal] = useState([]);
  const [balance, setBalance] = useState('0.00');
  const [name, setName] = useState('');
  const [uid, setUid] = useState('');
  const navigate = useNavigate();



  useEffect(() => {
    // Fetch metals data
    const interval = setInterval(() => {
      fetch('https://wealthmcx.com/Rest5/metals_api')
        .then((response) => response.json())
        .then((responseJson) => {
          setMetal(responseJson);
        })
        .catch((error) => {
          console.log(error);
        });
    }, 2000);

    // Fetch user data and wallet balance
    const fetchData = async () => {
      try {
        const uid = localStorage.getItem("userid");
        const name = localStorage.getItem("name");
        setName(name || 'User');
        setUid(uid);

        if (uid) {
          const response = await fetch('https://wealthmcx.com/Rest5/wallet_api/' + uid);
          const responseJson = await response.json();
          setBalance(responseJson.wallet || '0.00');
        }
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="wallet-container">
      {/* Top Gradient Background */}
  

      <div className="wallet-content">
        {/* Header with Profile */}
        

        {/* Total Balance Card */}
        <div className="balance-card">
          <div className="balance-content">
            <span className="balance-label">FUNDS AVAILABLE</span>
            <div className="balance-amount">
              <span>₹{balance}</span>
              <button className="eye-btn">
                <i className="fa fa-eye"></i>
              </button>
            </div>
            <div className="balance-change positive">
              <span>+0.00 (0.0%)</span>
              <i className="fa fa-arrow-up"></i>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="quick-actions">
          <div className="row g-3">
            <div className="col-md-4 col-6">
              <button 
                className="action-btn deposit"
                onClick={() => navigate("/deposite")}
              >
                <i className="fa fa-download"></i>
                <span>DEPOSIT</span>
              </button>
            </div>
            <div className="col-md-4 col-6">
              <button 
                className="action-btn withdraw"
                onClick={() => navigate("/withdrawl")}
              >
                <i className="fa fa-arrow-up"></i>
                <span>WITHDRAW</span>
              </button>
            </div>
            {/* <div className="col-md-4 col-4">
              <button 
                className="action-btn deposit"
                onClick={() => navigate("/transactions")}
              >
                  <i className="far fa-credit-card"></i>
                <span>PORTFOLIO</span>
              </button>
            </div> */}
          </div>
        </div>

        {/* Portfolio Section */}
        <div className="portfolio-section">
         
          {/* Metal Cards */}
          <div className="metal-cards">
            {metal.map((item, index) => {
              // Determine icon and color based on metal type
              let icon, color;
              switch(item.metal) {
                case 'Gold':
                  icon = <i className="fa fa-coins" style={{ color: '#FFD700' }}></i>;
                  color = '#FFD700';
                  break;
                case 'Silver':
                  icon = <i className="fa fa-coins" style={{ color: '#C0C0C0' }}></i>;
                  color = '#C0C0C0';
                  break;
                default:
                  icon = <i className="fa fa-gem" style={{ color: '#1E40AF' }}></i>;
                  color = '#1E40AF';
              }

              const isPositive = parseFloat(item.chg) >= 0;
              
              return (
                <div 
                  key={index} 
                  className="metal-card"
                  onClick={() => navigate("/buy/"+ item.metal )}
                >
                  <div className="metal-info">
                    <div className="metal-icon">
                      {icon}
                    </div>
                    <div className="metal-details">
                      <h4>{item.metal} {item.cont_date}</h4>
                      <div className="metal-stats">
                        <div className="stat-item">
                          <span className="stat-label">Open</span>
                          <span className="stat-value open">₹{item.open}</span>
                        </div>
                        <div className="stat-item">
                          <span className="stat-label">High</span>
                          <span className="stat-value high">₹{item.high}</span>
                        </div>
                        <div className="stat-item">
                          <span className="stat-label">Low</span>
                          <span className="stat-value low">₹{item.low}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="metal-rate">
                    <span className="rate-value">₹{item.rate}</span>
                    <span className={`rate-change ${isPositive ? 'positive' : 'negative'}`}>
                      {item.chg}
                      <i className={`fa fa-arrow-${isPositive ? 'up' : 'down'}`}></i>
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalletUI;